import type { IValidatorParams } from "@edaz/services/baseValidationService";

export interface IsIBANOptions {
  validate?: (entity: any) => boolean;
}

export default function isIBAN(value: string | undefined, options?: IsIBANOptions, params?: IValidatorParams) {
  if (options?.validate && !options.validate(params?.entity)) {
    return true;
  }

  const regexp = /^[A-Z]{2}[0-9]{2}([A-Z]|[a-z]|[0-9]){1,30}$/;

  if (value) {
    return regexp.test(value);
  }

  return true;
}
